import React from 'react';
import { motion } from 'framer-motion';

/**
 * Faixa de vídeo minimalista: só eyebrow + frase, sem CTA.
 * O véu é leve e concentrado à esquerda, atrás do texto — o resto do
 * quadro fica limpo para a filmagem aparecer.
 */
export default function LukosSolutionsSplit() {
  return (
    <section className="relative w-full overflow-hidden bg-[#0b0520]">

      {/* ── VÍDEO ── */}
      <div className="absolute inset-0 z-0">
        <video
          autoPlay
          muted
          loop
          playsInline
          preload="metadata"
          poster="/lukos_tech_bg.png"
          aria-hidden
          className="h-full w-full object-cover object-[center_40%] [filter:brightness(1.12)_contrast(1.06)_saturate(1.08)]"
        >
          <source src="/smartpos-pista.mp4" type="video/mp4" />
        </video>

        {/* véu leve, só o suficiente para o texto ter contraste à esquerda */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#0b0520]/90 via-[#0b0520]/35 to-transparent" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0b0520]/70 via-transparent to-transparent" />
      </div>

      {/* ── CONTEÚDO ── */}
      <div className="relative z-10 mx-auto flex min-h-[380px] max-w-[1280px] items-center px-6 py-16 sm:px-10 lg:min-h-[420px] lg:px-16">

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, ease: "easeOut" }}
          className="max-w-[500px]"
        >
          <p className="mb-5 text-[10px] font-bold uppercase tracking-[0.28em] text-[#00D1FF]">
            •&nbsp;&nbsp;SOLUÇÕES LUKOS
          </p>

          <h2 className="text-[26px] font-semibold leading-[1.1] tracking-tight text-white sm:text-[32px] lg:text-[34px] [text-shadow:0_2px_24px_rgba(11,5,32,0.6)]">
            Seu posto na máxima eficiência operacional.
          </h2>

          <p className="mt-4 max-w-[400px] text-[13.5px] leading-[1.65] text-white/65 sm:text-[14px]">
            Tecnologia para simplificar processos, blindar seu faturamento
            e transformar a gestão do seu negócio.
          </p>
        </motion.div>

      </div>

    </section>
  );
}
